<template>
  <div class="payment-success-page">
    <!-- 成功图标 -->
    <div class="success-icon-wrapper">
      <div class="success-circle">
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
          <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
        </svg>
      </div>
    </div>

    <!-- 标题 -->
    <h1 class="title">Payment Successful</h1>
    <p class="subtitle">Your payment has been processed successfully. Thank you for your purchase!</p>

    <!-- 倒计时 + 按钮 -->
    <div class="footer-actions">
      <div class="countdown-wrapper">
        <span class="countdown-text">
          Redirecting in {{ countdown }}s
        </span>
        <div class="progress-bar">
          <div 
            class="progress-fill" 
            :style="{ width: progressPercent + '%' }"
          ></div>
        </div>
      </div>

      <Button size="medium" @click="goHome">
      	Back to Home
    	</Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button/Button.vue';

export default {
  name: 'PaymentSuccessPage',

  components: {
		Button
	},
  
  data() {
    return {
      countdown: 5,
      timer: null,
      orderId: 'ORD' + Date.now().toString().slice(-10),
      amount: '299.00',
      paymentMethod: '',
      payTime: this.formatTime(new Date()),
      maxCountdown: 5,
    }
  },

  computed: {
    progressPercent() {
      return ((this.maxCountdown - this.countdown) / this.maxCountdown) * 100
    }
  },

  mounted() {
    this.startCountdown()
  },

  beforeDestroy() {
    this.clearTimer()
  },

  methods: {
    // 开始倒计时
    startCountdown() {
      this.clearTimer()
      this.timer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          this.clearTimer()
          this.goHome()
        }
      }, 1000)
    },

    // 清除定时器
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    // 跳转首页
    goHome() {
      this.clearTimer()
      this.$router.push({
        path: `/user_center`,
        query: {}
      });
    },

    // 格式化时间
    formatTime(date) {
      const pad = n => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>

<style scoped>
/* ===== 全局重置 ===== */
.payment-success-page {
  min-height: 100vh;
  padding: 40px 20px 30px;
  background: linear-gradient(145deg, #f5f7fa 0%, #e8ecf1 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

/* ===== 成功图标 - 带动画 ===== */
.success-icon-wrapper {
  margin-bottom: 20px;
}

.success-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: #7D52F4;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 30px rgba(82, 196, 26, 0.35);
  animation: popIn 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  transform: scale(0);
}

@keyframes popIn {
  0% { transform: scale(0); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

.checkmark {
  width: 50px;
  height: 50px;
}

.checkmark-circle {
  stroke: #fff;
  stroke-width: 4;
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  animation: strokeCircle 0.6s ease 0.3s forwards;
}

.checkmark-check {
  stroke: #fff;
  stroke-width: 4;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: strokeCheck 0.4s ease 0.5s forwards;
}

@keyframes strokeCircle {
  to { stroke-dashoffset: 0; }
}
@keyframes strokeCheck {
  to { stroke-dashoffset: 0; }
}

/* ===== 标题 ===== */
.title {
  font-size: 26px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 6px;
  letter-spacing: 1px;
}

.subtitle {
  font-size: 15px;
  color: #6b7280;
  margin: 0 0 28px;
  text-align: center;
  line-height: 1.5;
}

/* ===== 订单卡片 ===== */
.order-card {
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 16px;
  padding: 18px 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  margin-bottom: 24px;
  box-sizing: border-box;
}

.order-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}
.order-item:last-child {
  border-bottom: none;
}

.order-item .label {
  font-size: 14px;
  color: #8c8f9c;
}
.order-item .value {
  font-size: 14px;
  color: #1a1a2e;
  font-weight: 500;
}
.order-item .value.amount {
  color: #f5222d;
  font-weight: 700;
  font-size: 16px;
}

/* ===== 温馨提示 ===== */
.tips {
  width: 100%;
  max-width: 400px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 10px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #389e0d;
  margin-bottom: 32px;
  box-sizing: border-box;
}
.tips-icon {
  font-size: 18px;
}

/* ===== 底部操作区 ===== */
.footer-actions {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: auto;
  padding-bottom: 10px;
  box-sizing: border-box;
}

/* 倒计时 */
.countdown-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.countdown-text {
  font-size: 14px;
  color: #8c8f9c;
  letter-spacing: 0.5px;
}

.progress-bar {
  width: 100%;
  height: 4px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #7D52F4, #389e0d);
  border-radius: 4px;
  transition: width 1s linear;
}

/* 首页按钮 */
.btn-home {
  width: 100%;
  padding: 16px 0;
  background: linear-gradient(135deg, #1677ff, #0958d9);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 6px 20px rgba(22, 119, 255, 0.30);
  letter-spacing: 0.5px;
}

.btn-home:active {
  transform: scale(0.96);
  box-shadow: 0 3px 10px rgba(22, 119, 255, 0.25);
}

.home-icon {
  width: 22px;
  height: 22px;
}

/* ===== 响应式适配 ===== */
@media (max-width: 420px) {
  .payment-success-page {
    padding: 30px 16px 20px;
  }
  .title {
    font-size: 22px;
  }
  .success-circle {
    width: 76px;
    height: 76px;
  }
  .checkmark {
    width: 42px;
    height: 42px;
  }
  .order-card {
    padding: 14px 16px;
  }
  .order-item .label,
  .order-item .value {
    font-size: 13px;
  }
  .btn-home {
    font-size: 15px;
    padding: 14px 0;
  }
}

/* 适配刘海屏 / 全面屏底部安全区 */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .payment-success-page {
    padding-bottom: calc(30px + env(safe-area-inset-bottom));
  }
}
</style>